import {formatCurrencyPrefix} from "../../../utils/formatCurrency";

export default function BestProduct(data) {
    return (
        <div className="col-xxl-3 col-sm-6">

            <div className="card h-100">
                <div className="card-header border-bottom border-gray-100 flex-between flex-wrap gap-8">
                    <h5 className="mb-0">Best Products</h5>
                    
                </div>
                <div className="card-body">

                    <div className="">
                        <span className="text-gray-200 text-lg mb-12 mt-10 d-block text-center">Total Sales</span>
                        <h1 className="text-48 fw-medium mb-12 text-center"> 
                            {formatCurrencyPrefix(data?.data?.total_orders_global)} x
                        </h1>
                        
                        <div className="mt-20">
                            {
                                data?.data?.data?.map((item, index) => (
                                    <div className="bg-primary-50 rounded-16 p-12 flex-between flex-wrap gap-8 mb-16">
                                        <div className="flex-align gap-16">
                                            <span className="w-48 h-48 rounded-8 flex-center text-xl bg-primary-600 text-white"><i className="ph ph-image"></i></span>
                                            <div>
                                                <h2 className="mb-0 fw-medium text-primary-600">{item?.total_orders} x</h2>
                                                <small className="text-gray-600">{item?.product_name}</small>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                            
                            
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}